import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "step-6-set-the-delivery-method"
    }}>{`Step 6. Set the delivery method`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`setShippingMethodsOnCart`}</inlineCode>{` mutation defines the delivery methods for your order. It requires these input parameters:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`cart_id`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`carrier_code`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`method_code`}</inlineCode></li>
    </ul>
    <p><inlineCode parentName="p">{`{ CART_ID }`}</inlineCode>{` is the unique shopping cart ID from `}<a parentName="p" {...{
        "href": "../../tutorials/checkout/add-product-to-cart.md"
      }}>{`Step 2. Create empty cart`}</a>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`carrier_code`}</inlineCode>{` and `}<inlineCode parentName="p">{`method_code`}</inlineCode>{` values come from the response of the `}<inlineCode parentName="p">{`setShippingAddressesOnCart`}</inlineCode>{` mutation on the `}<a parentName="p" {...{
        "href": "set-shipping-address.md"
      }}>{`Set the shipping address`}</a>{` step.`}</p>
    <p>{`For logged-in customers, send the customer's authorization token in the `}<inlineCode parentName="p">{`Authorization`}</inlineCode>{` parameter of the header. See `}<a parentName="p" {...{
        "href": "../../usage/authorization-tokens.md"
      }}>{`Authorization tokens`}</a>{` for more information.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <p>{`The following mutation assigns Table Rate method.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  setShippingMethodsOnCart(input: {
    cart_id: "{ CART_ID }"
    shipping_methods: [
      {
        carrier_code: "tablerate"
        method_code: "bestway"
      }
    ]
  }) {
    cart {
      shipping_addresses {
        selected_shipping_method {
          carrier_code
          method_code
          carrier_title
          method_title
        }
      }
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "setShippingMethodsOnCart": {
      "cart": {
        "shipping_addresses": [
          {
            "selected_shipping_method": {
              "carrier_code": "tablerate",
              "method_code": "bestway",
              "carrier_title": "Best Way",
              "method_title": "Table Rate"
            }
          }
        ]
      }
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "verify-this-step"
    }}>{`Verify this step`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Sign in as a customer to the website using the email `}<inlineCode parentName="p">{`john.doe@example.com`}</inlineCode>{` and password `}<inlineCode parentName="p">{`b1b2b3l@w+`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Go to Checkout.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The selected delivery method is displayed in the Shipping Methods section on the Shipping step.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      